import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-item-count',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (total > 0) {
      <div class="row justify-content-center">
        <div class="col-auto">
          <span>Showing {{ start }} - {{ end }} of {{ total }}</span>
        </div>
      </div>
    }
  `})
export class ItemCountComponent {
  @Input() page = 1;
  @Input() total = 0;
  @Input() itemsPerPage = 20;
  @Input() maxSize?: number;

  get start(): number {
    return this.total === 0 ? 0 : (this.page - 1) * this.itemsPerPage + 1;
  }

  get end(): number {
    return Math.min(this.page * this.itemsPerPage, this.total);
  }
}
